import { animate, timeline } from 'motion';

import CardPatternAnimator from '../components/CardV2PatternAnimator';
import { Component } from '@verndale/core';
import Splitting from 'splitting';
import debounce from 'lodash/debounce';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      overlay: this.el.querySelector('.insight-cards-item-v2__overlay'),
      text: this.el.querySelector('.right-rail__cta-text')
    };

    this.handleResize();
  }

  addListeners() {
    this.addCardListeners();
    window.addEventListener(
      'resize',
      debounce(this.handleResize.bind(this), 300)
    );
  }

  addCardListeners() {
    this.el.addEventListener('mouseenter', this.handleCardHoverIn.bind(this));
    this.el.addEventListener('mouseleave', this.handleCardHoverOut.bind(this));
  }

  handleCardHoverIn(e) {
    if (!this.isMobile) {
      const sequence = [
        [this.dom.text, { duration: 0.15, at: 0.05, color: '#fff' }]
      ];
      sequence.push([
        this.dom.overlay,
        {
          transform: ['skew(-45deg) scale(0, 1)', 'skew(-45deg) scale(2, 1)']
        },
        { duration: 0.5, at: 0 }
      ]);

      timeline(sequence);
    }
  }

  handleCardHoverOut(e) {
    if (!this.isMobile) {
      const sequence = [
        [this.dom.text, { duration: 0.15, at: 0.05, color: '#000' }]
      ];
      timeline(sequence);
      animate(
        this.dom.overlay,
        { transform: 'skew(-45deg) scale(0, 1)' },
        { duration: 0.5 }
      );
    }
  }

  handleResize() {
    this.isMobile = window.matchMedia('(max-width: 1025px)').matches;
    if (!this.isMobile) {
      this.addCardListeners();
    }
  }
}

export default Module;
